import React, { useState, useEffect } from "react";

// CalendarDay component (a single day in the CalendarPicker)
const CalendarDay = (props) => {
    const {dayOfTheWeek, month, year, date, disabled = false, selectedDay, setSelectedDay} = props;
    const dayNames = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
    const formattedDate = (year != undefined && month != undefined && date != undefined) ? year + '-' + (month + 1).toString().padStart(2, '0') + '-' + date.toString().padStart(2, '0') : '';

    return (
        <button
            className={`calendar-picker__day ${(selectedDay == formattedDate ? 'calendar-picker__day--selected' : '')}`}
            dayOfTheWeek={dayNames[dayOfTheWeek]}
            month={month}
            year={year}
            disabled={disabled}
            onClick={() => setSelectedDay(formattedDate)}
        >
            {date}
        </button>
    );
}

// CalendarPicker component (used to quickly pick a day in the future)
const CalendarPicker = (props) => {
    const {acfData, selectedDay, setSelectedDay} = props;
    const [currentMonth, setCurrentMonth] = useState(new Date().getMonth());
    const [currentYear, setCurrentYear] = useState(new Date().getFullYear());
    const [isActive, setIsActive] = useState(false);
    const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

    // update currentMonth and currentYear when selectedDay changes (shows correct month if selection changes via carousel)
    useEffect(() => {
        if (selectedDay) {
            let monthAbbr = selectedDay.match(/\w{3}/);
            months.forEach((month, index) => {
                if (month.includes(monthAbbr)) {
                    setCurrentMonth(index);
                } 
            });
            setCurrentYear(selectedDay.match(/\d{4}/));
        }
    }, [selectedDay]);

    // generate the next ninty days    
    const nextSixtyDays = [];
    for (let i = 0; i < 60; i++) {
        let today = new Date();
        let nextDay = new Date(today.setDate(today.getDate() + i));

        if (acfData && acfData.acf.ticket_dates_cutoff && nextDay > new Date(acfData.acf.ticket_dates_cutoff)) {
            break;
        }

        nextSixtyDays.push(
            {
                day_of_the_week: nextDay.getDay(),
                month: nextDay.getMonth(),
                year: nextDay.getFullYear(),
                date: nextDay.getDate()
            }
        );
    }

    // filter to show the current month's days
    const currentMonthsDays = nextSixtyDays.filter((day) => {
        return day.month === currentMonth;
    });

    // add passed days to the start of the month, if any
    while (currentMonthsDays[0].date !== 1) {
        currentMonthsDays.unshift(
            {
                day_of_the_week: (currentMonthsDays[0].day_of_the_week == 0) ? currentMonthsDays[0].day_of_the_week + 6 : currentMonthsDays[0].day_of_the_week - 1,
                date: currentMonthsDays[0].date - 1,
                disabled: true
            }
        );
    }

    // add future days (beyond next 60) to the last month if necessary
    if (currentMonth === nextSixtyDays[nextSixtyDays.length - 1].month) {
        let finalMonth = nextSixtyDays[nextSixtyDays.length - 1].month;
        let finalYear = nextSixtyDays[nextSixtyDays.length - 1].year;
        let daysInFinalMonth = new Date(finalYear, finalMonth + 1, 0).getDate();

        while (currentMonthsDays.length < daysInFinalMonth) {
            currentMonthsDays.push(
                {
                    day_of_the_week: (currentMonthsDays[currentMonthsDays.length - 1].day_of_the_week == 6) ? 0 : currentMonthsDays[currentMonthsDays.length - 1].day_of_the_week + 1,
                    date: currentMonthsDays[currentMonthsDays.length - 1].date + 1,
                    disabled: true
                }
            );
        }
    }

    // show previous month
    function prevMonth() {
        if (currentMonth != nextSixtyDays[0].month) {
            if (currentMonth === 0) {
                setCurrentMonth(11);
                setCurrentYear(currentYear - 1);
            } else {
                setCurrentMonth(currentMonth - 1)
            }
        }
    }

    // show next month
    function nextMonth() {
        if (currentMonth != nextSixtyDays[nextSixtyDays.length - 1].month) {
            if (currentMonth === 11) {
                setCurrentMonth(0);
                setCurrentYear(currentYear + 1);
            } else {
                setCurrentMonth(currentMonth + 1)
            }
        }
    }

    return (
        <div class="ticket-select__calendar">
            {/*<button
                className="ticket-select__calendar-trigger button button--blue button--small"
                onClick={() => setIsActive(!isActive)}
            >
                <img className="ticket-select__calendar-icon" src="/wp-content/themes/speak/assets/icons/ui/calendar-icon.svg" alt="calendar icon"/>
                Schedule Ahead
            </button>*/}
            <div className={`calendar-picker ${isActive ? 'calendar-picker--active' : ''}`}>
                <p className="calendar-picker__note">Tickets may be purchased up to 60 days in advance.</p>
                <button
                    className="calendar-picker__close"
                    onClick={() => setIsActive(!isActive)}
                >
                    <i className="fa fa-close"></i>
                    <span className="sr-only">Close calendar</span>
                </button>
                <div className="calendar-picker__month-nav">
                    <button
                        className="calendar-picker__month-nav-button calendar-picker__month-nav-button--prev"
                        onClick={prevMonth}
                        disabled={currentMonth === nextSixtyDays[0].month}
                    >
                        <i className="fa fa-chevron-left"></i>
                        <span className="sr-only">Previous month</span>
                    </button>
                    <h5 className="calendar-picker__month-name">{months[currentMonth]} {currentYear}</h5>
                    <button
                        className="calendar-picker__month-nav-button calendar-picker__month-nav-button--next"
                        onClick={nextMonth}
                        disabled={currentMonth === nextSixtyDays[nextSixtyDays.length - 1].month}
                    >
                        <i className="fa fa-chevron-right"></i>
                        <span className="sr-only">Next month</span>
                    </button>
                </div>
                <table className="calendar-picker__month-grid">
                    <thead>
                        <tr>
                            <th>S</th>
                            <th>M</th>
                            <th>T</th>
                            <th>W</th>
                            <th>T</th>
                            <th>F</th>
                            <th>S</th>
                        </tr>
                    </thead>
                    <tbody>
                        {currentMonthsDays.map(day => {
                            return <CalendarDay
                                dayOfTheWeek={day.day_of_the_week}
                                month={day.month}
                                year={day.year}
                                date={day.date}
                                selectedDay={selectedDay}
                                setSelectedDay={setSelectedDay}
                                disabled={day.disabled}
                            />;
                        })}
                    </tbody>
                </table>
            </div>
        </div>
    );
}

export default CalendarPicker;